import { render, staticRenderFns } from "./SlideTopDashboard.vue?vue&type=template&id=2b0366f7&scoped=true"
import script from "./SlideTopDashboard.vue?vue&type=script&lang=js"
export * from "./SlideTopDashboard.vue?vue&type=script&lang=js"
import style0 from "./SlideTopDashboard.vue?vue&type=style&index=0&id=2b0366f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0366f7",
  null
  
)

export default component.exports